import React from "react";

const RecentOrdersIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M5.5 4.25L6.1 4.85L6.7 4.25L7.3 4.85L7.9 4.25L8.5 4.85L9.1 4.25L9.7 4.85L10.3 4.25L10.9 4.85L11.5 4.25L12.1 4.85L12.7 4.25L13.3 4.85L13.9 4.25L14.5 4.85V15.15L13.9 15.75L13.3 15.15L12.7 15.75L12.1 15.15L11.5 15.75L10.9 15.15L10.3 15.75L9.7 15.15L9.1 15.75L8.5 15.15L7.9 15.75L7.3 15.15L6.7 15.75L6.1 15.15L5.5 15.75V4.25Z"
      fill="rgba(124, 58, 237, 0.12)"
      stroke="#7C3AED"
      strokeWidth="1.15"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.35V12.65"
      stroke="#7C3AED"
      strokeWidth="1.15"
      strokeLinecap="round"
    />
    <path
      d="M8.4 8.85C8.4 8.2 8.95 7.7 10 7.7C11.05 7.7 11.6 8.2 11.6 8.7C11.6 9.35 11 9.7 10 9.7C8.9 9.7 8.4 10.1 8.4 10.7C8.4 11.35 8.95 11.85 10 11.85C11.05 11.85 11.6 11.35 11.6 10.8"
      stroke="#7C3AED"
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RecentOrdersIcon;
